<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <template v-if="qa_details">
          <div class="card-outlined py-2 px-4 mb-5">
            <div class="flex items-center mb-8">
              <base-svg-icon class="w-12 md:w-14 text-blue-500 mr-2" :path="mdiHelpCircle" />
              <h1 class="flex-1 whitespace-pre-wrap text-2xl md:text-3xl">{{ qa_details.question_title }}</h1>
            </div>
            <div class="whitespace-pre-wrap mb-6">{{qa_details.question_body}}</div>
          </div>
          <div class="card-outlined py-2 px-4">
            <div class="flex items-center mb-8">
              <base-svg-icon class="w-12 md:w-14 text-yellow-500 mr-2" :path="mdiLightbulbOn70" />
              <h1 class="flex-1 whitespace-pre-wrap text-2xl md:text-3xl">{{ qa_details.answer_title }}</h1>
            </div>
            <div class="whitespace-pre-wrap mb-6">{{qa_details.answer_body}}</div>
          </div>
        </template>
        <template v-else>
          ページが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { axios, ApiResponse } from '@/plugins/axios'
import { mdiHelpCircle, mdiLightbulbOn70 } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
// import { QAListAttributes } from '@/types/models/qa-list'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BaseSvgIcon
  },
  setup() {
    const route = useRoute()
    const qa_details = ref()

    onMounted(() => {
      axios
        .get(`/qa/list/${route.params.qa_list_id}`)
        .then(response => {
          qa_details.value = response.data.payload
        })
    })

    return {
      mdiHelpCircle,
      mdiLightbulbOn70,
      qa_details
    }
  }
})
</script>
